import { useState } from 'react';
import { Link } from 'react-router-dom';
import { promptApi, type AIGeneration } from '../../api/media';

export function GenerationHistoryPage() {
  const [generations, setGenerations] = useState<AIGeneration[]>([]);
  const [promptId, setPromptId] = useState('');
  const [loading, setLoading] = useState(false);

  async function run() {
    if (!promptId.trim()) return;
    setLoading(true);
    try {
      const gen = await promptApi.generate({ prompt_id: promptId.trim(), create_asset: true });
      setGenerations((g) => [gen, ...g]);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/media/prompts" className="text-sm text-slate-600 hover:underline">← Prompt library</Link>
      <h1 className="mt-4 text-2xl font-semibold">AI Generation History</h1>
      <div className="mt-6 flex gap-3">
        <input value={promptId} onChange={(e) => setPromptId(e.target.value)} placeholder="Prompt ID to generate" className="flex-1 rounded-lg border px-3 py-2 text-sm" />
        <button disabled={loading} onClick={() => void run()} className="rounded-lg bg-slate-900 px-4 py-2 text-sm text-white">{loading ? 'Running…' : 'Run'}</button>
      </div>
      <ul className="mt-6 space-y-3 text-sm">
        {generations.map((g) => (
          <li key={g.id} className="rounded-xl border bg-white p-4">
            <p className="font-medium">{g.id}</p>
            <p className="text-slate-500">Prompt {g.prompt_id} · {g.status}</p>
            {g.output_url && <a href={g.output_url} className="text-slate-700 hover:underline" target="_blank" rel="noreferrer">Output</a>}
            {g.asset_id && <Link to={`/media/assets/${g.asset_id}`} className="ml-3 text-slate-700 hover:underline">View asset</Link>}
          </li>
        ))}
        {generations.length === 0 && <p className="text-slate-500">No generations in this session yet.</p>}
      </ul>
    </div>
  );
}
